import { BreadcrumbsProps } from './breadcrumbs.types';
import { NavLink } from 'react-router-dom';
import styles from './breadcrumbs.module.css';
import classNames from 'classnames';

export const Breadcrumbs = ({ crumbs, className }: BreadcrumbsProps) => {
  return (
    <nav className={classNames(styles.crumbs, className)}>
      {crumbs.map((c, i) => (
        <div key={c.link}>
          <NavLink
            to={c.link}
            key={c.link}
            className={({ isActive }) =>
              `${styles.crumb} ${isActive ? styles.crumb__active : undefined}`
            }
          >
            {c.display}
          </NavLink>
          {i < crumbs.length - 1 && (
            <span key={`${c.link}_sep`} className={styles.crumb__separator}>
              /
            </span>
          )}
        </div>
      ))}
    </nav>
  );
};
